/**
 *  검색 키워드 페이지 이름
 */
export const SEARCH_WORD_PAGE_NAME = {
  SEARCH_WORD_LIST: '검색 키워드 리스트',
  SEARCH_WORD_CREATE: '검색 키워드 등록',
  SEARCH_WORD_EDIT: '검색 키워드 편집',
};

/**
 *  검색 키워드 기간 검색 타입
 */
export const SEARCH_WORD_SEARCH_DATE_TYPE = {
  /**
   *  생성일
   */
  CREATE_DATE: 0,
  /**
   *  키워드 검색 기간
   */
  SEARCH_KEYWORD_DATE: 1,
};

/**
 *  검색 키워드 기간 검색 타입 TEXT
 */
export const SEARCH_WORD_SEARCH_DATE_TYPE_TEXT = {
  [SEARCH_WORD_SEARCH_DATE_TYPE.CREATE_DATE]: '생성일',
  [SEARCH_WORD_SEARCH_DATE_TYPE.SEARCH_KEYWORD_DATE]: '키워드 검색 기간',
};

/**
 *  검색 키워드 기간 검색 타입 SELECT LIST
 */
export const SEARCH_WORD_SEARCH_DATE_TYPE_SELECT_LIST = [
  {
    id: null,
    name: '전체',
  },
  {
    id: SEARCH_WORD_SEARCH_DATE_TYPE.CREATE_DATE,
    name: SEARCH_WORD_SEARCH_DATE_TYPE_TEXT[SEARCH_WORD_SEARCH_DATE_TYPE.CREATE_DATE],
  },
  {
    id: SEARCH_WORD_SEARCH_DATE_TYPE.SEARCH_KEYWORD_DATE,
    name: SEARCH_WORD_SEARCH_DATE_TYPE_TEXT[SEARCH_WORD_SEARCH_DATE_TYPE.SEARCH_KEYWORD_DATE],
  },
];

/**
 *  입력 가능한 최대 연관 키워드 수
 */
export const MAXIMUM_NUMBER_OF_RELATED_KEYWORD_LIST = 10;
